export const getDelayFromError = error => {
  const responseData = error?.response?.data
  const delay = Number(responseData?.error?.vars?.delay || responseData?.alert?.vars?.delay)

  return Number.isFinite(delay) && delay > 0 ? delay : 0
}

export const getVarsFromError = error =>
  error?.response?.data?.error?.vars || error?.response?.data?.alert?.vars || {}

export const isCodeResendTooFrequentError = error => {
  const responseData = error?.response?.data
  const responseError = responseData?.error || responseData?.alert || {}
  const errorCode = responseError.code || responseError.name || responseError.msg?.name

  return error?.response?.status === 429 || errorCode === 'err-code-resend-too-frequent'
}

export const getMaskedPhoneNumber = phone => {
  const value = phone || ''
  const digits = value.replace(/\D/g, '')

  if (digits.length < 11) return value

  const lastFourDigits = digits.slice(-4)
  const countryCode = `+${digits.slice(0, digits.length - 10)}`

  return `${countryCode} (***) ***-${lastFourDigits.slice(0, 2)}-${lastFourDigits.slice(2)}`
}

export const normalizeVerificationCode = (value, codeLength) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, codeLength)

export const getSecondsUntilResend = (requestedAt, delayBeforeCodeResend) => {
  const requestedAtMs = Number(requestedAt) || new Date(requestedAt).getTime()

  if (!Number.isFinite(requestedAtMs)) return 0

  const elapsedSeconds = Math.floor((Date.now() - requestedAtMs) / 1000)
  const secondsRemaining = delayBeforeCodeResend - elapsedSeconds

  return secondsRemaining > 0 ? secondsRemaining : 0
}

export const getRecipientMaskByDeliveryType = ({
  deliveryType,
  recipientMask,
  phoneMask,
  emailMask,
}) => {
  if (deliveryType === 'email') {
    return emailMask || recipientMask || phoneMask
  }

  return phoneMask || recipientMask || emailMask
}

export const getResendTooFrequentPopupText = labels => {
  const text = labels.CODE_RESEND_TOO_FREQUENT_ERROR || labels.resendTooFrequentError

  return text && !/(\d+\s*(сек|мин|second|minute)|смс|sms)/i.test(text)
    ? text
    : 'Вам необходимо подождать, прежде чем Вы сможете запросить новый код'
}
